<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>

<section *ngIf="permissionsReady && !permissions.canView">
    <div class="no-access-wrapper">
        <div class="no-access-card">
            <h4>No Access</h4>
            <p class="mb-0">You don't have permission to view string configuration.</p>
        </div>
    </div>
</section>

<section *ngIf="permissionsReady && permissions.canView">
    <div class="card table-card">
        <div class="table-toolbar">
            <h1 class="table-toolbar__title">String Configuration</h1>
            <div class="sb-filter-holder sb-filter-holder--inline">
                <button type="button" class="btn btn-dark" *ngIf="permissions.canAdd"
                    (click)="openConfigModal(configModal)">+ Set Configuration</button>
                <div class="btn-group input-wrapper sb-filter-search-group" role="group">
                    <input type="text" class="sb-filter-field sb-filter-search-input"
                        placeholder="Search inverter model" (input)="searchData($event)">
                    <button type="button" class="btn sb-filter-search-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                            fill="none">
                            <path
                                d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="table-wrap" [class.is-loading]="tableLoader">
            <div class="loaderwrapper" *ngIf="tableLoader">
                <span class="loader"></span>
            </div>
            <div class="table-main">
                <table class="table-data text-center">
                    <thead>
                        <tr>
                            <th scope="col" class="text-start">Inverter Model</th>
                            <th scope="col">No. of Strings</th>
                            <th scope="col">Devices</th>
                            <th scope="col">Last Updated</th>
                            <th scope="col" *ngIf="permissions.canAdd || permissions.canEdit">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!tableLoader">
                            <tr *ngFor="let row of rows">
                                <td class="text-start">{{ row.invType }}</td>
                                <td>{{ row.no_of_strings ?? '—' }}</td>
                                <td>{{ row.device_count }}</td>
                                <td>{{ row.updated_at ? (row.updated_at | date: 'medium') : '—' }}</td>
                                <td *ngIf="permissions.canAdd || permissions.canEdit">
                                    <ul class="list-inline hstack gap-2 mb-0 justify-content-center">
                                        <li class="list-inline-item edit" title="Edit">
                                            <a class="d-inline-block edit-item-btn" role="button"
                                                [attr.aria-label]="'Edit strings for ' + row.invType"
                                                (click)="openConfigModal(configModal, row)">
                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M14.4271 2.55876L12.4231 0.55468C12.0535 0.198814 11.5605 0 11.0475 0C10.5344 0 10.0414 0.198814 9.67183 0.55468L8.19147 2.05599L1.62759 8.59194C1.5773 8.64607 1.5392 8.71036 1.51586 8.78048L0.0773974 13.1098C0.0317216 13.2354 0.00580956 13.3673 0.000586046 13.5009C0.000586046 13.5009 0.000586046 13.5009 0.000586046 13.5428C-0.0066797 13.7872 0.0537341 14.0288 0.175157 14.2411C0.175157 14.2411 0.217054 14.2899 0.23102 14.3179C0.281294 14.4043 0.342295 14.4841 0.412574 14.5553C0.542741 14.6881 0.698117 14.7936 0.869587 14.8655C1.04106 14.9374 1.22517 14.9744 1.41112 14.9743C1.56556 14.9732 1.71882 14.9473 1.86501 14.8975L6.19437 13.459C6.26482 13.433 6.32904 13.3926 6.38291 13.3403L12.9258 6.79036L14.4271 5.28207C14.6123 5.10028 14.7585 4.88272 14.857 4.64263C14.9554 4.40255 15.004 4.14495 14.9997 3.8855C14.9874 3.38589 14.7822 2.91043 14.4271 2.55876ZM6.0198 12.237L4.37883 10.603L2.73786 8.96203L8.53363 3.17325L11.8156 6.4482L6.0198 12.237ZM1.52285 13.9268H1.39017C1.32518 13.9222 1.26255 13.9006 1.20862 13.864C1.14263 13.799 1.10286 13.712 1.09689 13.6196C1.09068 13.5756 1.09068 13.5309 1.09689 13.4869L1.20862 12.9423L2.03958 13.7732L1.52285 13.9268ZM3.14985 13.3892L1.59268 11.832L2.22811 9.93265L3.62468 11.3292L5.02125 12.7258L3.14985 13.3892ZM13.687 4.56982L12.5557 5.70802L9.27381 2.42608L10.412 1.29486C10.5808 1.12686 10.8093 1.03254 11.0475 1.03254C11.2856 1.03254 11.5141 1.12686 11.6829 1.29486L13.687 3.29894C13.855 3.46775 13.9493 3.69622 13.9493 3.93438C13.9493 4.17254 13.855 4.40101 13.687 4.56982Z"
                                                        fill="currentColor" />
                                                </svg>
                                            </a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr *ngIf="rows.length === 0">
                                <td colspan="100%">
                                    <p class="not-found-message p-4 text-center">No inverter models found.</p>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="table-meta" *ngIf="!tableLoader && rows.length > 0">
                <div class="entries">
                    <span>Total Records: {{ totalRecords }}</span>
                </div>
                <nav class="table-pagination">
                    <ul>
                        <li><a class="init-bg" (click)="goToPage(1)" [class.disabled]="currentPage === 1">1</a></li>
                        <li><a class="no-bg" (click)="navigatePage('prev')" [class.disabled]="currentPage === 1"><i class="fa fa-chevron-left"></i></a></li>
                        <li><a class="active">{{ currentPage }}</a></li>
                        <li><a class="no-bg" (click)="navigatePage('next')" [class.disabled]="currentPage === totalPages"><i class="fa fa-chevron-right"></i></a></li>
                        <li><a class="init-bg" (click)="goToPage(totalPages)" [class.disabled]="currentPage === totalPages">{{ totalPages }}</a></li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</section>

<ng-template #configModal let-c="close" let-d="dismiss">
    <form [formGroup]="form" (ngSubmit)="save(c)">
        <div class="modal-header">
            <h4 class="modal-title">{{ editingInvType ? 'Edit String Configuration' : 'Set String Configuration' }}</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="d('Cancel click')"></button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
                <label class="form-label">Inverter Model</label>
                <ng-select [items]="inverterModels" bindLabel="invType" bindValue="invType" [clearable]="false"
                    placeholder="Select inverter model" formControlName="invType"
                    (change)="onModelChange($event?.invType)">
                    <ng-template ng-option-tmp let-item="item">
                        {{ item.invType }} ({{ item.device_count }} device{{ item.device_count === 1 ? '' : 's' }})
                    </ng-template>
                </ng-select>
                <small class="text-danger" *ngIf="form.get('invType')?.touched && form.get('invType')?.invalid">
                    Inverter model is required.
                </small>
            </div>
            <div>
                <label class="form-label">No. of Strings</label>
                <input type="number" min="0" class="form-control" formControlName="no_of_strings"
                    placeholder="Enter number of strings" />
                <small class="text-danger"
                    *ngIf="form.get('no_of_strings')?.touched && form.get('no_of_strings')?.invalid">
                    Enter a number of 0 or more.
                </small>
                <small class="text-muted d-block mt-1">Applies to every device using this inverter model.</small>
            </div>
        </div>
        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" (click)="d('Cancel click')">Cancel</button>
            <button type="submit" class="btn btn-orange" [disabled]="saving">
                {{ saving ? 'Saving...' : 'Save' }}
            </button>
        </div>
    </form>
</ng-template>
